<div class="lib-custom-filter-holder" #dropdown>
  <lib-dropdown
    [reference]="dropdown"
    [positions]="dropdownPositions"
    [config]="filterConfig"
    [customClass]="customClass"
    #dropdownFilter
  >
    <div class="drop-down">
      <div
        class="drop-down__title text-center text-uppercase"
        (click)="dropdownFilter.hide()"
      >
        {{ colDef.headerName }}
      </div>

      <div class="drop-down__sort" *ngIf="colDef.sortable">
        <button
          icon
          lib-icon-btn
          iconType="sort-up"
          class="mr-4"
          (click)="onSortRequest('asc', $event)"
          [ngClass]="{
            active: activeSort === 'asc'
          }"
        ></button>

        <button
          icon
          lib-icon-btn
          iconType="sort-down"
          class="ml-4"
          (click)="onSortRequest('desc', $event)"
          [ngClass]="{
            active: activeSort === 'desc'
          }"
        ></button>
      </div>

      <hr *ngIf="colDef.filterWithSearchBox">

      <div class="filter-user-input-box" *ngIf="colDef.filterWithSearchBox">
        <input #filterTextField class="filter-user-input" placeholder="Filter ..."
         [ngModel]="searchBoxInput" (ngModelChange)="onChangeInputValue($event)" />
      </div>

      <overlay-scrollbars
        class="drop-down__filter-options"
        *ngIf="colDef.filterActive"
        [ngClass]="getFilterListScrollClass()"
        #filterOptionList
      >
        <ul class="drop-down__filter-options__list">
          <ng-container *ngIf="(filterDisplayOptions$ | async).length > 0">
            <li
              class="drop-down__filter-options__item"
              title="{{ filterItem.displayName }}"
              *ngFor="let filterItem of (filterDisplayOptions$ | async)"
              (click)="onChange(filterItem)"
              [ngClass]="{'active-option': text === filterItem.displayName}"
            >
            {{ filterItem.displayName }}
            </li>
          </ng-container>
          <ng-container *ngIf="(filterDisplayOptions$ | async).length === 0">
            <li class="drop-down__filter-options__non-clickable-item" title="No results found">
              <b>No results found</b>
            </li>
          </ng-container>
        </ul>
      </overlay-scrollbars>

      <hr *ngIf="colDef.dateRangeFilterActive">

      <div class="drop-down__filter-date-range" *ngIf="colDef.dateRangeFilterActive">
          <lib-date-range
            class="drop-down__filter-date-range__picker"
            #dateRange
            [isDateRange]="true"
            [withConfirmation]="true"
            [selectMode]="true"
            [isDisabled]="false"
            [outsideClick]="false"
            [placement]="dateRangePlacement"
            [inputConfig]="dateRangeInputConfig"
            [configs]="dateRangeConfigs"
            (valueChange)="onDateRangeChange($event)"
          ></lib-date-range>
      </div>

      <hr *ngIf="colDef.numberRangeFilterActive">

      <div class="drop-down__filter-number-range" *ngIf="colDef.numberRangeFilterActive">
        <div class="number-range-inputs">
          <input
            class="number-range-input"
            placeholder="Min"
            type="number"
            [value]="numberRangeFrom"
            (input)="onNumberRangeChange('from', $event.target.value)"
          />
          <input
            class="number-range-input"
            type="number"
            placeholder="Max"
            [value]="numberRangeTo"
            (input)="onNumberRangeChange('to', $event.target.value)"
          />
        </div>
      </div>
    </div>
  </lib-dropdown>
</div>